export default __webpack_public_path__ + "static/media/rectangle.23b29038.svg";